import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { environment } from '../../shared/config/app-config';
import { PatientService, Puser, User, UserService } from '../../shared';
import { SucesstempComponent } from '../assessmentsucess/sucesstemp.component';

@Component({
  selector: 'app-exercisevideos',
  templateUrl: './exercisevideos.component.html',
  styleUrls: ['./exercisevideos.component.css']
})
export class ExercisevideosComponent implements OnInit {

  constructor(private userService: UserService, private modalService: BsModalService, private dialog: MatDialog, private patientService: PatientService, private router: ActivatedRoute, private http: HttpClient) { }
  oneAtATime: boolean = true;
  CurrentUser: User;
  resp: any;
  PUser: Puser;
  imageURL: string = environment.cloudeImageURL;
  activityboard: any
  modalRef: BsModalRef;
  documenturl: string = environment.documenturl;
  videoDescriptionURL: string = environment.videoDescriptionurl;
  dccpDam: string = environment.lib_base;
  excersiseVideo: any = [];
  success: MatDialogRef<SucesstempComponent>;

  /* excersiseVideo:any = [ {
    "episodeName": "Preop Exercises",
    "data": [{
      "materialId": 4,
      "materialName": "Preop Exercises",
      "materialType": "Video",
      "filePath": "/careinfiniRepository/video/Risks of Hip Surgery.mp4",
      "productId": 0,
      "isPatReviewed": false,
      "assignedDate": "-",
      "dueDate": "-",
      "patReviewedDate": "-",
      "episodeId": 6541,
      "episodeName": "Prepare for Surgery",
      "materialHspPatientMappingId": 43299,
      "isClinicianReviewed": false,
      "description": "The great majority of hip replacement surgeries are complication free and result in significant pain relief and restoration of mobility. ",
      "clinicanPart": null,
      "patientId": 6020747,
      "reviewStatus": "Not Assigned",
      "patientEpisodeTrackId": 68384,
      "priority": "4",
      "shortTitle": "Risks of Hip Surgery"
    }]
  }, {
    "episodeName": "Postop Exercises",
    "data": [{
      "materialId": 4,
      "materialName": "Postop Exercises",
      "materialType": "Video",
      "filePath": "/careinfiniRepository/video/Risks of Hip Surgery.mp4",
      "productId": 0,
      "isPatReviewed": false,
      "assignedDate": "-",
      "dueDate": "-",
      "patReviewedDate": "-",
      "episodeId": 6541,
      "episodeName": "Prepare for Surgery",
      "materialHspPatientMappingId": 43299,
      "isClinicianReviewed": false,
      "description": "The great majority of hip replacement surgeries are complication free and result in significant pain relief and restoration of mobility. ",
      "clinicanPart": null,
      "patientId": 6020747,
      "reviewStatus": "Not Assigned",
      "patientEpisodeTrackId": 68384,
      "priority": "4",
      "shortTitle": "Risks of Hip Surgery"
    }]
  }, { 
    "episodeName": "Postop Advanced",
    "data": [{
      "materialId": 4,
      "materialName": "Postop Advanced",
      "materialType": "Video",
      "filePath": "/careinfiniRepository/video/Risks of Hip Surgery.mp4",
      "productId": 0,
      "isPatReviewed": false,
      "assignedDate": "-",
      "dueDate": "-",
      "patReviewedDate": "-",
      "episodeId": 6541,
      "episodeName": "Prepare for Surgery",
      "materialHspPatientMappingId": 43299,
      "isClinicianReviewed": false,
      "description": "The great majority of hip replacement surgeries are complication free and result in significant pain relief and restoration of mobility. ",
      "clinicanPart": null,
      "patientId": 6020747,
      "reviewStatus": "Not Assigned",
      "patientEpisodeTrackId": 68384,
      "priority": "4",
      "shortTitle": "Risks of Hip Surgery"
    }]
  }, {
    "episodeName": "Postop Advanced Stairs",
    "data": [{
      "materialId": 4,
      "materialName": "Postop Advanced Stairs",
      "materialType": "Video",
      "filePath": "/careinfiniRepository/video/Risks of Hip Surgery.mp4",
      "productId": 0,
      "isPatReviewed": false,
      "assignedDate": "-",
      "dueDate": "-",
      "patReviewedDate": "-",
      "episodeId": 6541,
      "episodeName": "Prepare for Surgery",
      "materialHspPatientMappingId": 43299,
      "isClinicianReviewed": false,
      "description": "The great majority of hip replacement surgeries are complication free and result in significant pain relief and restoration of mobility. ",
      "clinicanPart": null,
      "patientId": 6020747,
      "reviewStatus": "Not Assigned",
      "patientEpisodeTrackId": 68384,
      "priority": "4",
      "shortTitle": "Risks of Hip Surgery"
    }]
  }]; */

  patid: any;
  patientSWFID: any;
  ngOnInit() {
    /** Get Current User Details Here */
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;

      }
    )
    this.userService.PUser.subscribe(
      (puserData) => {
        this.resp = puserData;
        this.PUser = puserData;

      }
    )

    /** Get Image URL based on deployment */
    if (this.CurrentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;

    /* this.patientSWFID = window.localStorage['Puser']; */
    this.patientSWFID = window.localStorage['Puser'];

    this.getAllVideoList();
  }

  /** Get Excercise Video Data list  */
  getAllVideoList() {
    /* window.localStorage['Puser'] */
    this.patientService.getExersiseVideo(window.localStorage['Puser'])
      .subscribe(data => {
        this.excersiseVideo = data;
      })
  }

  /** OnAccordian Pannel Change change the accordian icon  */
  openChangeEvent(event: boolean, i) {

    this.excersiseVideo[i].open = event;
  };


  /** Open particular Video on onClick */
  selectedItem: any;
  openVideo(videoModelTemp, _selectedItem) {
    this.selectedItem = _selectedItem;
    this.enablevideo = true
    this.modalRef = this.modalService.show(videoModelTemp, { backdrop: 'static' });
    this.userService.patientVideoMapId(this.selectedItem.materialHspPatientMappingId, 'open')
      .subscribe(
        data => {
          this.userService.logAudit("updatereviewstatus", 0).subscribe(data => { })
          /* this.selectedItem.isPatReviewed=true; */
        })
  }

  openPdf() {
    // this.modalRef.hide()
    // window.location.href = `${this.dccpDam}${this.selectedItem.pdfPath}`
    let a = document.createElement('a');
    a.target = '_blank';
    a.href = `${this.dccpDam}${this.selectedItem.pdfPath}`;
    a.click();
    // window.open(`${this.dccpDam}${this.selectedItem.pdfPath}`,'_blank')

  }
  /**  Download written instruction PDF for selected video */
  downloadInstructionPDF(filePath) {


    return this.http
      .get(this.dccpDam + filePath, {
        responseType: 'blob'
      })
      .map(res => {
        return {
          filename: 'filename.pdf',
          data: res
        };
      })
      .subscribe(res => {
        var url = window.URL.createObjectURL(res.data);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }, error => {
        //////console.log('download error:', JSON.stringify(error));
      }, () => {
        //////console.log('Completed file download.')
      });

  }

  /** Watched status change using this method */
  iWatchedIt() {
    this.userService.patientVideoMapId(this.selectedItem.materialHspPatientMappingId, 'complete')
      .subscribe(
        data => {
          this.userService.logAudit("updatereviewstatus", 0).subscribe(data => { })
          /* this.selectedItem.isPatReviewed=true; */
          if (!this.selectedItem.isPatReviewed) {
            this.userService.updatesurvey(this.selectedItem.materialHspPatientMappingId, this.selectedItem.materialType)
              .subscribe(data => { });

            this.getAllVideoList();
          }
        });
    this.modalRef.hide();

    this.success = this.dialog.open(SucesstempComponent, { disableClose: true });
    this.success.componentInstance.assessment = 'activity';
    this.success.componentInstance.message = 'completed';
    this.success.componentInstance.fullMessage = this.userService.translateText('patient_portal.assessment.submit_success.message')
  }


  /** Watched status change using this method */
  enablevideo: any = true
  iWatched(video) {
    if ((video.duration - video.currentTime) <= 4) {
      this.enablevideo = false
    } else {
      this.enablevideo = true
    }
  }
  getDownloadData(act) {
    let data: any = {
      'preview': false,
      'patientSwfId': this.patientSWFID,
      'stageCategoryId': act.episodeId,
      "lang": this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    window.open(this.videoDescriptionURL + data);
  }

}
